import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';

const swipers = document.querySelectorAll('.logo-slider');
if (swipers) {
    swipers.forEach((element) => {
        var id = element.id.replace('swiper-', '')
        var swiperid = "#swiper-" + id;
        new Swiper(swiperid, {
            modules: [Navigation],
            slidesPerView: 2,
            speed: 800,
            breakpoints: {
                640: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 4,
                },
                1024: {
                    slidesPerView: 6,
                },
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            }
        });

    })
}
